import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { debounceTime, map } from 'rxjs';

import { BreakpointActions } from './viewport.actions';
import { NinetyBreakpointNames, NinetyBreakpoints } from './viewport.model';

@Injectable()
export class ViewportStateEffects {
  private readonly breakpointObserver = inject(BreakpointObserver);

  observeBreakpoints$ = createEffect(() => {
    let breakpointNames: NinetyBreakpointNames[] | null = null;
    return this.breakpointObserver.observe(Object.values(NinetyBreakpoints)).pipe(
      debounceTime(150),
      map(breakpointState => {
        if (!breakpointNames) breakpointNames = Object.keys(NinetyBreakpoints) as NinetyBreakpointNames[];
        const matchingBreakpointIdx = breakpointState.matches
          ? Object.values(breakpointState.breakpoints).lastIndexOf(true)
          : breakpointNames.indexOf(NinetyBreakpointNames.Medium);
        const currentScreenSize = breakpointNames[matchingBreakpointIdx];
        return BreakpointActions.breakpointSet({ breakpointState, currentScreenSize });
      })
    );
  });
}
